import React, { useState } from 'react';

import { bool, shape, string } from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import FeatureOnboardingModal from 'components/Common/FeatureOnboardingModal';
import PageDetails from 'components/Common/LayoutV2/AppBar/PageDetails/components/PageDetails';
import useCompleteFeatureOnboarding from 'hooks/useCompleteFeatureOnboarding';
import useFeatureOnboardingList from 'hooks/useFeatureOnboardingList';
import useModal from 'hooks/useModal';

const PageDetailsContainer = ({
  title,
  modal,
  module,
  classes,
  hasFeatureOnboarding,
}) => {
  const user = useSelector(state => state.user);
  const { pathname } = useLocation();
  const { showModal, isModalVisible } = useModal();

  const [featureOnboardingModalOpen, setFeatureOnboardingModalOpen] =
    useState(false);

  const { data: featureOnboardings } = useFeatureOnboardingList({
    enabled: hasFeatureOnboarding,
  });
  const completeFeatureOnboarding = useCompleteFeatureOnboarding();

  const currentFeature = featureOnboardings?.find(feature =>
    pathname.includes(feature.feUrl),
  );

  const hasOnboardingModal = hasFeatureOnboarding && currentFeature;

  const openModal = () => {
    if (hasOnboardingModal) {
      setFeatureOnboardingModalOpen(true);
    } else {
      showModal(modal);
    }
  };

  const onCompleteFeatureOnboarding = payload => {
    completeFeatureOnboarding.mutate(payload);
  };

  const onboardingFeaturePending =
    currentFeature && !currentFeature.completed && !isModalVisible;

  return (
    <>
      <PageDetails
        title={title}
        classes={classes}
        modal={modal || hasOnboardingModal}
        openModal={openModal}
        module={module}
        onboardingFeaturePending={onboardingFeaturePending}
      />
      {hasOnboardingModal && (
        <FeatureOnboardingModal
          open={featureOnboardingModalOpen}
          onClose={() => setFeatureOnboardingModalOpen(false)}
          feature={currentFeature}
          completeFeatureOnboarding={onCompleteFeatureOnboarding}
          rewatching={currentFeature?.completed}
          user={user}
        />
      )}
    </>
  );
};

PageDetailsContainer.propTypes = {
  modal: string,
  module: string,
  title: string.isRequired,
  classes: shape({
    container: string,
    title: string,
  }),
  hasFeatureOnboarding: bool,
};

PageDetailsContainer.defaultProps = {
  modal: null,
  module: '',
  classes: {
    container: '',
    title: '',
  },
  hasFeatureOnboarding: false,
};

export default PageDetailsContainer;
